// A table row as a card, for phones: the stock and its status on top, the numbers that matter in a
// grid, actions at the bottom. Pages show these below the sm breakpoint and their tables above it.
import { cn } from '@/lib/utils';

export interface RowCardCell { label: string; value: React.ReactNode; className?: string }

export function RowCard({ title, sub, badge, cells, actions, tone }: {
  title: React.ReactNode; sub?: React.ReactNode; badge?: React.ReactNode; cells: RowCardCell[];
  actions?: React.ReactNode; tone?: 'warn';
}) {
  return (
    <div className={cn('rounded-xl border bg-card px-3 py-2.5 text-[13px]', tone === 'warn' && 'border-warn/40 bg-warn-soft/40')}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-ink">{title}</div>
          {sub && <div className="text-[11.5px] text-muted-foreground">{sub}</div>}
        </div>
        {badge}
      </div>
      {cells.length > 0 && (
        <dl className="mt-2 grid grid-cols-3 gap-x-3 gap-y-1.5">
          {cells.map((c) => (
            <div key={c.label} className="min-w-0">
              <dt className="truncate text-[10.5px] tracking-wide text-muted-foreground uppercase">{c.label}</dt>
              <dd className={cn('num truncate font-medium', c.className)}>{c.value}</dd>
            </div>
          ))}
        </dl>
      )}
      {actions && <div className="mt-2 flex flex-wrap items-center justify-end gap-1.5 border-t pt-2">{actions}</div>}
    </div>
  );
}

/** The card list's wrapper: phones only. */
export function RowCards({ children }: { children: React.ReactNode }) {
  return <div className="mt-2 grid gap-2 sm:hidden">{children}</div>;
}
